import { Hr_BettingInterest, Hr_Race } from "@/graphql/gql/graphql";
import { getFDRLink, getRunnerPick } from "@/utils/horseRacing";
import RaceDetailsRunnerRow from "./RaceDetailsRunnerRow";
import styles from "./raceDetailsTable.module.scss";

interface RaceDetailsTableProps {
  race: Hr_Race;
  trackCode: string;
  trackName: string;
  rows: Hr_BettingInterest[];
  consensusView?: boolean;
}

const RaceDetailsTable = ({
  race,
  trackCode,
  trackName,
  rows,
  consensusView = false,
}: RaceDetailsTableProps) => (
  <table className={styles.table}>
    <thead>
      <tr className={styles.subHeader}>
        <th className={styles.sticky}>#/Silk</th>
        <th className={styles.sticky}>
          <span className={styles.desktopLabel}>Horse</span>
          <span className={styles.mobileLabel}>#/Horse</span>
        </th>
        <th>Power Rating</th>
        <th>High Speed</th>
        <th>Win %</th>
        <th>Top 3%</th>
        <th>Win Prob</th>
        <th>Odds</th>
      </tr>
    </thead>
    {rows?.map((bets) =>
      bets?.runners?.[0] ? (
        <RaceDetailsRunnerRow
          numberColor={bets.numberColor ?? undefined}
          saddleColor={bets.saddleColor ?? undefined}
          runner={bets?.runners?.[0]}
          numerator={bets.currentOdds?.numerator ?? undefined}
          denominator={bets.currentOdds?.denominator ?? undefined}
          key={
            bets?.runners?.[0]?.entityRunnerId ?? bets?.runners?.[0]?.horseName
          }
          fdrLink={getFDRLink(
            trackCode ?? "",
            trackName ?? "",
            race.number ?? undefined
          )}
          trackDataSource={race.track?.trackDataSource ?? ""}
          info={
            getRunnerPick(bets?.runners?.[0], race.track?.trackDataSource ?? "")
              .info ?? undefined
          }
          isConsensusView={consensusView}
          trackName={trackName}
          raceNumber={race.number}
          postTime={race.postTime}
        />
      ) : (
        ""
      )
    )}
  </table>
);

export default RaceDetailsTable;
